export const CREDIT_PRICING = {
  talent: [
    { id: 'talent_1',  credits: 1,  price_ore: 9900,  price_sek: 99,  per_credit_sek: 99, label: '1 credit',    label_sv: '1 kredit',    badge: null,           savings_pct: 0  },
    { id: 'talent_10', credits: 10, price_ore: 79900, price_sek: 799, per_credit_sek: 80, label: '10 credits',  label_sv: '10 krediter', badge: 'Most popular', savings_pct: 19 },
  ],
  agency: [
    { id: 'agency_1',  credits: 1,  price_ore: 9900,  price_sek: 99,  per_credit_sek: 99, label: '1 credit',    label_sv: '1 kredit',    badge: null,           savings_pct: 0  },
    { id: 'agency_10', credits: 10, price_ore: 79900, price_sek: 799, per_credit_sek: 80, label: '10 credits',  label_sv: '10 krediter', badge: 'Most popular', savings_pct: 19 },
  ],
  vat_rate: 0.25,
  welcome_credits: 3,
};

// Badge label localisation (sentence case, no dashes in user-facing text).
export const BADGE_LABELS = {
  'Most popular': { en: 'Most popular', sv: 'Mest populär' },
  'Best value': { en: 'Best value', sv: 'Bäst värde' },
};

export const packsFor = (accountType) =>
  accountType === 'agency' ? CREDIT_PRICING.agency : CREDIT_PRICING.talent;


// ============================================================================
// SINGLE SOURCE OF TRUTH for all booking categories, specialities, event types,
// budgets and durations. Every page that touches these values MUST import here.
// Backend mirror: /app/backend/platform_constants.py (slugs must stay in sync).
// ============================================================================

export const CATEGORY_GROUPS = [
  {
    id: 'dj', label: 'DJ', labelSv: 'DJ',
    subtitle: 'Club, wedding, corporate, hybrid', subtitleSv: 'Klubb, bröllop, företag, hybrid', icon: 'headphones',
    specialities: [
      { id: 'nightclub_dj', label: 'Nightclub DJ', labelSv: 'Nattklubb-DJ' },
      { id: 'wedding_dj', label: 'Wedding DJ', labelSv: 'Bröllops-DJ' },
      { id: 'corporate_dj', label: 'Corporate event DJ', labelSv: 'Företagsevent-DJ' },
      { id: 'private_party_dj', label: 'Private party DJ', labelSv: 'Privat fest-DJ' },
      { id: 'festival_dj', label: 'Festival DJ', labelSv: 'Festival-DJ' },
      { id: 'lounge_dj', label: 'Lounge / Lobby DJ', labelSv: 'Lounge-DJ' },
      { id: 'club_night_dj', label: 'Club night DJ', labelSv: 'Klubbkväll-DJ' },
      { id: 'silent_disco_dj', label: 'Silent disco DJ', labelSv: 'Silent disco-DJ' },
      { id: 'hybrid_dj', label: 'Hybrid DJ (DJ + live)', labelSv: 'Hybrid-DJ (DJ + live)' },
      { id: 'live_dj_producer', label: 'Live DJ / producer', labelSv: 'Live DJ / producent' },
      { id: 'other', label: 'Other', labelSv: 'Annat' },
    ],
  },
  {
    id: 'live_music', label: 'Live Music', labelSv: 'Livemusik',
    subtitle: 'Bands, singers, instrumentalists', subtitleSv: 'Band, sångare, instrumentalister', icon: 'music',
    specialities: [
      { id: 'live_band', label: 'Live band', labelSv: 'Liveband' },
      { id: 'solo_singer', label: 'Solo singer', labelSv: 'Solosångare' },
      { id: 'acoustic_artist', label: 'Acoustic artist', labelSv: 'Akustisk artist' },
      { id: 'pianist', label: 'Pianist', labelSv: 'Pianist' },
      { id: 'saxophonist', label: 'Saxophonist', labelSv: 'Saxofonist' },
      { id: 'guitarist', label: 'Guitarist', labelSv: 'Gitarrist' },
      { id: 'string_quartet', label: 'String quartet', labelSv: 'Stråkkvartett' },
      { id: 'other', label: 'Other', labelSv: 'Annat' },
    ],
  },
  {
    id: 'hosts_entertainment', label: 'Hosts & Entertainment', labelSv: 'Värdar & Underhållning',
    subtitle: 'Toastmaster, MC, comedians, magicians', subtitleSv: 'Toastmaster, MC, komiker, magiker', icon: 'masks',
    specialities: [
      { id: 'toastmaster', label: 'Toastmaster', labelSv: 'Toastmaster' },
      { id: 'mc', label: 'Event MC', labelSv: 'Konferencier' },
      { id: 'moderator', label: 'Moderator', labelSv: 'Moderator' },
      { id: 'keynote_speaker', label: 'Keynote speaker', labelSv: 'Keynote-talare' },
      { id: 'comedian', label: 'Comedian', labelSv: 'Komiker' },
      { id: 'standup_comedian', label: 'Stand-up comedian', labelSv: 'Ståuppkomiker' },
      { id: 'improv', label: 'Improv', labelSv: 'Improv' },
      { id: 'comedy_mc', label: 'Comedy MC', labelSv: 'Komedi-MC' },
      { id: 'sketch_comedy', label: 'Sketch comedy', labelSv: 'Sketchkomedi' },
      { id: 'magician', label: 'Magician', labelSv: 'Trollkonstnär' },
      { id: 'dancer', label: 'Dancer', labelSv: 'Dansare' },
      { id: 'circus_artist', label: 'Circus artist', labelSv: 'Cirkusartist' },
      { id: 'caricaturist', label: 'Caricaturist', labelSv: 'Karikatyrtecknare' },
      { id: 'fire_performer', label: 'Fire performer', labelSv: 'Eldshow' },
      { id: 'other', label: 'Other', labelSv: 'Annat' },
    ],
  },
  {
    id: 'event_services', label: 'Event Services', labelSv: 'Eventtjänster',
    subtitle: 'Photo booth, bartenders, staff', subtitleSv: 'Fotobox, bartenders, personal', icon: 'sparkles',
    specialities: [
      { id: 'photo_booth', label: 'Photo booth', labelSv: 'Fotobox' },
      { id: 'bartender', label: 'Bartender', labelSv: 'Bartender' },
      { id: 'event_staff', label: 'Event staff', labelSv: 'Eventpersonal' },
      { id: 'other', label: 'Other', labelSv: 'Annat' },
    ],
  },
];

// Legacy group id -> new 4-category group id (used for data migration & lookups).
export const GROUP_MIGRATION = {
  music: 'live_music',
  hosts_speakers: 'hosts_entertainment',
  entertainment: 'hosts_entertainment',
  comedy: 'hosts_entertainment',
  experiences: 'event_services',
  dj: 'dj',
};

// Flat list of all "group__speciality" IDs for validation.
export const ALL_SPECIALITY_IDS = CATEGORY_GROUPS.flatMap((g) => g.specialities.map((s) => `${g.id}__${s.id}`));

export const getSpecialitiesForGroup = (groupId) => {
  const group = CATEGORY_GROUPS.find((g) => g.id === groupId);
  return group ? group.specialities : [];
};

export const getGroupLabel = (groupId, lang = 'en') => {
  const group = CATEGORY_GROUPS.find((g) => g.id === groupId);
  if (!group) return groupId || '';
  return lang === 'sv' ? group.labelSv : group.label;
};

export const getSpecialityLabel = (groupId, specialityId, lang = 'en') => {
  const group = CATEGORY_GROUPS.find((g) => g.id === groupId);
  if (!group) return specialityId || '';
  const spec = group.specialities.find((s) => s.id === specialityId);
  if (!spec) return specialityId || '';
  return lang === 'sv' ? spec.labelSv : spec.label;
};

/* Stämning. Fältet vibe_tags har funnits på förfrågan sedan början och visas i
   talangens gigvy och i admin, men inget formulär har någonsin skrivit det: det
   har alltid varit tomt. Taggarna är fritext i modellen, så listan här är förslag
   och inte en sluten mängd. Backend kapar till fem taggar och fyrtio tecken.

   Fem per grupp och inte femton: en lista man måste läsa igenom besvaras inte. */
export const VIBE_TAGS = [
  { id: 'elegant', label: 'Elegant', labelSv: 'Elegant' },
  { id: 'party', label: 'Party', labelSv: 'Fest' },
  { id: 'intimate', label: 'Intimate', labelSv: 'Intimt' },
  { id: 'formal', label: 'Formal', labelSv: 'Formellt' },
  { id: 'relaxed', label: 'Relaxed', labelSv: 'Avslappnat' },
  { id: 'dancefloor', label: 'Dancefloor', labelSv: 'Dansgolv' },
  { id: 'background', label: 'Background music', labelSv: 'Bakgrundsmusik' },
  { id: 'singalong', label: 'Sing-along', labelSv: 'Allsång' },
  { id: 'modern', label: 'Modern', labelSv: 'Modernt' },
  { id: 'classic', label: 'Classic', labelSv: 'Klassiskt' },
  { id: 'family', label: 'Family friendly', labelSv: 'Familjevänligt' },
  { id: 'outdoor', label: 'Outdoors', labelSv: 'Utomhus' },
];

export const MAX_VIBE_TAGS = 3;

export const EVENT_TYPES = [
  { id: 'corporate_event', label: 'Corporate event', labelSv: 'Företagsevent', primary: true },
  { id: 'private_party', label: 'Private party', labelSv: 'Privat fest', primary: true },
  { id: 'wedding', label: 'Wedding', labelSv: 'Bröllop', primary: true },
  { id: 'christmas_party', label: 'Christmas party / Julfest', labelSv: 'Julbord / Julfest', primary: true },
  { id: 'student_graduation', label: 'Student / Graduation', labelSv: 'Student / Examen', primary: true },
  { id: 'birthday_party', label: 'Birthday party', labelSv: 'Födelsedagsfest', primary: true },
  { id: 'club_night', label: 'Club night', labelSv: 'Klubbkväll' },
  { id: 'festival', label: 'Festival', labelSv: 'Festival' },
  { id: 'gala_awards', label: 'Gala or Awards', labelSv: 'Gala eller Utmärkelse' },
  { id: 'networking_event', label: 'Networking event', labelSv: 'Nätverksevent' },
  { id: 'team_building', label: 'Team building', labelSv: 'Teambuilding' },
  { id: 'product_launch', label: 'Product launch', labelSv: 'Produktlansering' },
  { id: 'other', label: 'Other', labelSv: 'Annat' },
];

export const getEventTypeLabel = (id, lang = 'en') => {
  const et = EVENT_TYPES.find((e) => e.id === id);
  if (!et) return id || '';
  return lang === 'sv' ? et.labelSv : et.label;
};

export const BUDGET_RANGES = [
  { id: 'under_5k', label: '< 5 000 kr', labelSv: '< 5 000 kr', min: 0, max: 5000 },
  { id: '5k_15k', label: '5 000 - 15 000 kr', labelSv: '5 000 - 15 000 kr', min: 5000, max: 15000 },
  { id: '15k_30k', label: '15 000 - 30 000 kr', labelSv: '15 000 - 30 000 kr', min: 15000, max: 30000 },
  { id: 'above_30k', label: '30 000 kr+', labelSv: '30 000 kr+', min: 30000, max: null },
];

export const DURATION_OPTIONS = [
  { id: '1h', label: '1 hour', labelSv: '1 timme', hours: 1 },
  { id: '2h', label: '2 hours', labelSv: '2 timmar', hours: 2 },
  { id: '3h', label: '3 hours', labelSv: '3 timmar', hours: 3 },
  { id: '4h', label: '4 hours', labelSv: '4 timmar', hours: 4 },
  { id: '5h', label: '5 hours', labelSv: '5 timmar', hours: 5 },
  { id: '6h_plus', label: '6+ hours', labelSv: '6+ timmar', hours: 6 },
];

// Native / primary language(s) per supported country (ISO 3166-1 alpha-2).
export const COUNTRY_LANGUAGES = {
  SE: ['Swedish'], NO: ['Norwegian'], DK: ['Danish'], FI: ['Finnish', 'Swedish'],
  DE: ['German'], AT: ['German'], CH: ['German', 'French', 'Italian'],
  FR: ['French'], BE: ['Dutch', 'French'], NL: ['Dutch'],
  IT: ['Italian'], ES: ['Spanish'], PT: ['Portuguese'], PL: ['Polish'],
  IE: [], GB: [], US: [], CA: ['French'], AU: [], AE: ['Arabic'],
};

// Common languages always offered as toggleable options (English is locked-on).
export const COMMON_LANGUAGES = [
  'Swedish', 'Norwegian', 'Danish', 'Finnish', 'German', 'French',
  'Spanish', 'Italian', 'Dutch', 'Polish', 'Portuguese', 'Arabic',
];

// English is always first (and locked in the UI); the selected country's native
// language(s) surface next, followed by the common set. De-duplicated.
export const languageOptions = (countryCode) => {
  const native = COUNTRY_LANGUAGES[countryCode] || [];
  return [...new Set(['English', ...native, ...COMMON_LANGUAGES])];
};

export const START_TIMES = Array.from({ length: 38 }, (_, i) => {
  const totalMinutes = 8 * 60 + i * 30;
  const h = Math.floor(totalMinutes / 60) % 24;
  const m = totalMinutes % 60;
  const labelStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  return { id: labelStr, label: labelStr };
});
